import { get, post } from "../requestapi";
import msg from "@/assets/js/msg.js";

const home = {
  //请求网站配置
  login(val) {
    return post("/login", val);
  },
  // 提交个人认证
  userAtt(val) {
    return post("/userAtt", val);
  },
  scenes(val) {
    return get("/scenes", val);
  },
  sheet(val) {
    return get("/sheet", val);
  },
  async song(val) {
    let data = []
    await get("/song", val).then(res => {
      if (res.code == 200) {
        data = res.data
      }
    })
    return data
  },
  sheetDetail(val) {
    return get("/sheetDetail", val);
  },
  sheetSongs(val) {
    return get("/sheetSongs", val);
  },
  getAuditionSong(val) {
    return get("/getAuditionSong", val);
  },
  getCollection(val) {
    return get("/getCollection", val);
  },
  cartScenes(val) {
    return get("/cartScenes", val);
  },
  cart(val) {
    return get("/cart", val);
  },
  addCart(val) {
    return get("/addCart", val);
  },
  collection(val) {
    return post("/collection", val);
  },
  cancelCollection(val) {
    return post("/cancelCollection", val);
  },
  getAttestat(val) {
    return get("/getAttestat", val);
  },
  getCode(val) {
    return post("/getCode", val);
  },
  attribute(val) {
    return get("/attribute", val);
  },
  prices(val) {
    return get("/prices", val);
  },
  addCart(val) {
    return post("/addCart", val);
  },
  orders(val) {
    return get("/orders", val);
  },
  delGoods(val) {
    return post("/delGoods", val);
  },
  labels(val) {
    return get("/labels", val);
  },
  placeOrder(val) {
    return post("/placeOrder", val);
  },
  upload(val) {
    return post("/upload", val);
  },
  companyAtt(val) {
    return post("/companyAtt", val);
  },
  auditionSong(val) {
    val.show = true;
    return post("/auditionSong", val);
  },
  orderInfo(val) {
    val.show = true;
    return get("/orderInfo", val);
  },
  qrPay(val) {
    return post("/qrPay", val);
  },
  applyEmpower(val) {
    return post("/applyEmpower", val);
  },
  invoicing(val) {
    return post("/invoicing", val);
  },
  links(val) {
    return get("/links", val);
  },
  delOrder(val) {
    return post("/delOrder", val);
  },
  editAuthInfo(val) {
    return post("/editAuthInfo", val);
  },
  downEmpo(val) {
    return get("/downEmpo", val);
  },
  // 底部列表
  articleList(val) {
    return get("/articleList", val);
  },
  // 底部详情
  articleDetail(val) {
    return get("/articleDetail", val);
  },
  //合作案例
  case(val) {
    return get("/case", val);
  },
  payStatus(val) {
    val.show = true;
    return get("/payStatus", val);
  },
  downloadSongs(val) {
    val.show = true;
    return get("/downloadSongs", val);
  },
  async homeData(val) {
    let data = []
    await get("/home", val).then(res => {
      if (res.code == 200) {
        data = res.data
      }
    })
    return data
  },
  async groupsRecSheets(val) {
    let data = []
    await get("/groupsRecSheets", val).then(res => {
      if (res.code == 200) {
        data = res.data
      }
    })
    return data
  },
  async groupRecSheets(val) {
    let data = []
    await get("/groupRecSheets", val).then(res => {
      if (res.code == 200) {
        data = res.data
      }
    })
    return data
  },
  async getSheetSongs(val) {
    let data = []
    await get("/getSheetSongs", val).then(res => {
      if (res.code == 200) {
        data = res.data
      }
    })
    return data
  },
  async groupsCases(val) {
    let data = []
    await get("/groupsCases", val).then(res => {
      if (res.code == 200) {
        data = res.data
      }
    })
    return data
  },
  async cancellation(val) {
    let data = []
    await post("/cancellation", val).then(res => {
      data = res
    })
    return data
  },
  async caseDetail(val) {
    let data = []
    await get("/caseDetail", val).then(res => {
      if (res.code == 200) {
        data = res.data
      }
    })
    return data
  },
  async groupCases(val) {
    let data = []
    await get("/groupCases", val).then(res => {
      if (res.code == 200) {
        data = res.data
      }
    })
    return data
  },
  async detailHelp(val) {
    let data = []
    await get("/detailHelp", val).then(res => {
      if (res.code == 200) {
        data = res.data
      }
    })
    return data
  },
  async helps(val) {
    let data = []
    await get("/helps", val).then(res => {
      if (res.code == 200) {
        data = res.data
      }
    })
    return data
  },
  async services(val) {
    let data = []
    await get("/services", val).then(res => {
      if (res.code == 200) {
        data = res.data
      }
    })
    return data
  },
  async setPrompt(val) {
    let data = []
    await post("/setPrompt", val).then(res => {
      if (res.code == 200) {
        data = res.data
      }
    })
    return data
  },
  async noticeOfflinePay(val) {
    let data = []
    await post("/noticeOfflinePay", val).then(res => {
      if (res.code == 200) {
        data = res
      }
    })
    return data
  },
  async orderDetail(val) {
    let data = []
    await get("/orderDetail", val).then(res => {
      if (res.code == 200) {
        data = res
      }
    })
    return data
  },
  async downInvoice(val) {
    let data = []
    await post("/downInvoice", val).then(res => {
      if (res.code == 200) {
        data = res.data
      }else{
        msg("error", "提示", res.msg);
      }
    })
    return data
  },
  async operArticleDetail(val) {
    let data = []
    await get("/operArticleDetail", val).then(res => {
      if (res.code == 200) {
        data = res.data
      }else{
        msg("error", "提示", res.msg);
      }
    })
    return data
  },
  async operSongs(val) {
    let data = []
    await get("/operSongs", val).then(res => {
      if (res.code == 200) {
        data = res.data
      }else{
        msg("error", "提示", res.msg);
      }
    })
    return data
  },
  async operSongLabel(val) {
    let data = []
    await get("/operSongLabel", val).then(res => {
      if (res.code == 200) {
        data = res.data
      }else{
        msg("error", "提示", res.msg);
      }
    })
    return data
  },
  async previewCert(val) {
    let data = []
    await post("/previewCert", val).then(res => {
      const blob = new Blob([res])
      data = blob
      // if (res.code == 200) {
      // }else{
      //   msg("error", "提示", res.msg);
      // }
    })
    return data
  },
  idCardCheck(val) {
    return post("/idCard/check", val);
  },
};
export default home;
